import type { ReactNode } from 'react';
import { createContext, useContext } from 'react';

import type { EntityLevel } from '@suntex.fim/enums';

import type { SwitchEntity } from '../useSwitchEntity';

export interface EntityContext {
  entityLevel: EntityLevel;
  entityId: number | undefined;
  switchEntity: SwitchEntity;
}

const EntityContext = createContext<EntityContext | null>(null);

export function EntityProvider({
  entityLevel,
  entityId,
  switchEntity,
  children,
}: EntityContext & { children: ReactNode }) {
  return (
    <EntityContext.Provider value={{ entityLevel, entityId, switchEntity }}>
      {children}
    </EntityContext.Provider>
  );
}

/** Read the current entity level and id set by the enclosing layout wrapper. */
export function useEntityContext(): EntityContext {
  const ctx = useContext(EntityContext);
  if (ctx == null) {
    throw new Error(
      'useEntityContext must be called inside a FIM layout wrapper',
    );
  }
  return ctx;
}
